import type { Game } from "../../data/games";
import { RecommendedGameCard } from "../RecommendedGameCard/RecommendedGameCard";
import styles from "./RecommendedGames.module.css";

interface RecommendedGamesProps {
  games: readonly Game[];
  onSelectGame: (game: Game, trigger: HTMLButtonElement) => void;
}

export function RecommendedGames({
  games,
  onSelectGame,
}: RecommendedGamesProps) {
  return (
    <section className={styles.section} aria-labelledby="recommended-heading">
      <div className={styles.heading}>
        <span className={styles.eyebrow}>Utvalt för gruppen</span>
        <h2 id="recommended-heading">Rekommenderat för er</h2>
      </div>

      <div
        className={styles.list}
        role="list"
        aria-label="Rekommenderade spel"
      >
        {games.map((game) => (
          <div className={styles.item} role="listitem" key={game.id}>
            <RecommendedGameCard game={game} onSelect={onSelectGame} />
          </div>
        ))}
      </div>
    </section>
  );
}
